import store from '@/store';

export default function useModal() {
  const openModal = () => {
    store.commit('baseComponent/OPEN_MODAL');
  };

  const closeModal = () => {
    store.commit('baseComponent/CLOSE_MODAL');
  };

  return { openModal, closeModal };
}
